import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = [".open"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { slot: "footer" }
const _hoisted_6 = ["disabled"]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { EPINIO_TYPES } from '../../types';
import { epinioExceptionToErrorsArray } from '../../utils/errors';
import Banner from '@components/Banner/Banner.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigurationDeleteModal',
  setup(__props, { expose: __expose }) {

const store = useStore() as any;
const t = store.getters['i18n/t'];

const showModal = ref(false);
const configToDelete = ref<any>(null);
const deleting = ref(false);
const errors = ref<string[]>([]);

const boundApps = computed(() => configToDelete.value?.configuration?.boundapps || []);

function openDelete(row: any) {
  configToDelete.value = row;
  errors.value = [];
  showModal.value = true;
}

function closeDelete() {
  showModal.value = false;
  errors.value = [];
  configToDelete.value = null;
}

async function onSubmitDelete() {
  if (!configToDelete.value) return;

  deleting.value = true;
  errors.value = [];

  try {
    const cfg = configToDelete.value;
    const configName = cfg.meta?.name;
    const namespace = cfg.meta?.namespace;

    // Unbind all bound apps before deleting
    if (boundApps.value.length) {
      const nsApps = store.getters['epinio/all'](EPINIO_TYPES.APP)
        .filter((a: any) => a.meta.namespace === namespace);

      await Promise.all(
        nsApps
          .filter((a: any) => boundApps.value.includes(a.metadata.name))
          .map((a: any) => a.unbindConfiguration([configName]))
      );
    }

    await cfg.remove();
    closeDelete();
    store.dispatch('epinio/findAll', { type: EPINIO_TYPES.CONFIGURATION, opt: { force: true } });
    store.dispatch('epinio/findAll', { type: EPINIO_TYPES.APP, opt: { force: true } });
  } catch (e: any) {
    errors.value = epinioExceptionToErrorsArray(e);
  } finally {
    deleting.value = false;
  }
}

__expose({ openDelete });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("trailhand-modal", {
    ".open": showModal.value,
    title: "Are you sure?",
    onModalClose: closeDelete
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode("You are attempting to delete the configuration ", -1)),
        _createElementVNode("strong", null, _toDisplayString(configToDelete.value?.meta?.name), 1),
        _cache[1] || (_cache[1] = _createTextVNode(".", -1))
      ]),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (boundApps.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, [
              _createElementVNode("strong", null, "Caution: "),
              _createTextVNode("The following applications are bound to this configuration. Proceeding will unbind them prior to deletion.")
            ], -1)),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boundApps.value, (app) => {
                return (_openBlock(), _createElementBlock("li", { key: app }, _toDisplayString(app), 1))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, "\n        No applications are bound to this configuration.\n      ")),
      _cache[5] || (_cache[5] = _createTextVNode()),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (err, i) => {
        return (_openBlock(), _createBlock(Banner, {
          key: i,
          color: "error",
          label: err
        }, null, 8, ["label"]))
      }), 128))
    ]),
    _cache[7] || (_cache[7] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("trailhand-button", {
        variant: "secondary",
        class: "mr-10",
        onButtonClick: closeDelete
      }, "\n        Cancel\n      ", 32),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("trailhand-button", {
        variant: "destructive",
        disabled: deleting.value,
        onButtonClick: onSubmitDelete
      }, _toDisplayString(deleting.value ? 'Deleting...' : _unref(t)('generic.delete')), 41, _hoisted_6)
    ])
  ], 40, _hoisted_1))
}
}

})